import { useMutation, useQuery } from "@tanstack/react-query";
import { api } from "../components/api";
import { useSnackbar } from "../components/AppComponents/SnackBarProvider";
import { SEVERITY } from "../utils/messages";

export const useProductsQuery = (query) => {
  return useQuery({
    queryKey: ["products", query],
    queryFn: () => api.product.getAllProducts(query),
    keepPreviousData: true,
    select: (data) => data?.data,
    onError: (error) => {
      console.error("Error fetching product:", error);
    },
  });
};

export const useTaskDropDownQuery = (query) => {
  return useQuery({
    queryKey: ["task", query],
    queryFn: () => api.centralTask.getAllCentralTasks(query),
    select: (data) => data?.data,
    onError: (error) => {
      console.error("Error fetching task:", error);
    },
  });
};

export const useCreateProduct = () => {
  const { updateSnackbar } = useSnackbar();
  return useMutation({
    mutationKey: ["create-product"],
    mutationFn: (payload) => api.product.createProduct(payload),
    onSuccess: (data) => {
    
    },
    onError: (error) => {
      updateSnackbar({
        severity: SEVERITY.error,
        message: error?.message,
      });
      console.error("Error:", error);
    },
  });
};

export const useUpdateProduct = (id, responseHandler) => {
  const { updateSnackbar } = useSnackbar();
  return useMutation({
    mutationKey: ["update-product", id],
    mutationFn: (payload) => api.product.updateProductById(id, payload),
    onSuccess: (data) => {
      responseHandler?.();
    
    },
    onError: (error) => {
      updateSnackbar({
        severity: SEVERITY.error,
        message: error?.message,
      });
      console.error("Error:", error);
    },
  });
};

export const useDeleteProduct = (responseHandler) => {
  const { updateSnackbar } = useSnackbar();
  return useMutation({
    mutationKey: ["delete-product"],
    mutationFn: (payload) => api.product.deleteProductById(payload),
    onSuccess: (data) => {
      responseHandler?.();
      updateSnackbar({
        severity: SEVERITY.success,
        message: data?.message,
      });
    },
    onError: (error) => {
      updateSnackbar({
        severity: SEVERITY.error,
        message: error?.message,
      });
      console.error("Error:", error);
    },
  });
};

export const useDeleteProductDocument = () => {
  const { updateSnackbar } = useSnackbar();
  return useMutation({
    mutationKey: ["delete-product-document"],
    mutationFn: (documentId) => api.product.deleteProductDocument(documentId),
    onSuccess: (data) => {
      updateSnackbar({
        severity: SEVERITY.success,
        message: data?.message,
      });
    },
    onError: (error) => {
      updateSnackbar({
        severity: SEVERITY.error,
        message: error?.message,
      });
      console.error("Error:", error);
    },
  });
};

export const useDeleteProductTaskDocument = () => {
  const { updateSnackbar } = useSnackbar();
  return useMutation({
    mutationKey: ["delete-product-task-document"],
    mutationFn: (documentId) => api.product.deleteProductTaskDocument(documentId),
    onSuccess: (data) => {
      updateSnackbar({
        severity: SEVERITY.success,
        message: data?.message,
      });
    },
    onError: (error) => {
      updateSnackbar({
        severity: SEVERITY.error,
        message: error?.message,
      });
      console.error("Error:", error);
    },
  });
};

export const useExportProducts = () => {
  const { updateSnackbar } = useSnackbar();
  return useMutation({
    mutationKey: ["export-products"],
    mutationFn: (queryParams = {}) => api.product.downloadProductsCsv(queryParams),
    onSuccess: (data) => {
      updateSnackbar({
        severity: SEVERITY.success,
        message: "Products exported successfully",
      });
    },
    onError: (error) => {
      updateSnackbar({
        severity: SEVERITY.error,
        message: error?.message,
      });
      console.error("Export error:", error);
    },
  });
};

export const useProductById = (id, responseHandler) => {
  const { updateSnackbar } = useSnackbar();

  return useQuery({
    queryKey: ["product", id],
    queryFn: () => api.product.getProductById(id),
    enabled: !!id,
    select: (data) => data?.data,
    onSuccess: (data) => responseHandler?.(data),
    onError: (error) => {
      console.error("Error fetching product details:", error);
      updateSnackbar({
        severity: SEVERITY.error,
        message: error?.message,
      });
    },
  });
};
